"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var lodash_1 = require("lodash");
var antd_1 = require("antd");
var formik_1 = require("formik");
var Col_1 = __importDefault(require("../Col"));
var contexts_1 = require("../../contexts");
var useValidation_1 = __importDefault(require("../../hooks/useValidation"));
var Permission_1 = __importDefault(require("../Permission"));
var FormatText_1 = __importDefault(require("../FormatText"));
var FormItem = function (props) {
    var name = props.name, label = props.label, span = props.span, validate = props.validate, validateSchema = props.validateSchema, required = props.required, viewPermission = props.viewPermission, editPermission = props.editPermission, children = props.children;
    var formProps = react_1.useContext(contexts_1.FormContext).formProps;
    var validateField = useValidation_1.default({ validate: validate, validateSchema: validateSchema, required: required })[0];
    return (react_1.default.createElement(Col_1.default, { span: span },
        react_1.default.createElement(Permission_1.default, { viewPermission: viewPermission, editPermission: editPermission }, !formProps ? (react_1.default.createElement(antd_1.Form.Item, { label: label && react_1.default.createElement(FormatText_1.default, { id: label }), colon: false, hasFeedback: true }, children)) : (react_1.default.createElement(formik_1.Field, { name: name, validate: validateField }, function (_a) {
            var _b = _a.form.errors, errors = _b === void 0 ? {} : _b;
            var error = lodash_1.get(errors, name, undefined);
            var errorMsg = error ? error.toString() : undefined;
            var validateStatus = error ? 'error' : undefined;
            return (react_1.default.createElement(antd_1.Form.Item, { label: label && react_1.default.createElement(FormatText_1.default, { id: label }), help: errorMsg && react_1.default.createElement(FormatText_1.default, { id: errorMsg }), validateStatus: validateStatus, colon: false, hasFeedback: true }, children));
        })))));
};
exports.withFormItem = function (WrappedComponent) {
    return function (props) {
        var name = props.name, label = props.label, span = props.span, validate = props.validate, validateSchema = props.validateSchema, required = props.required, viewPermission = props.viewPermission, editPermission = props.editPermission, fieldProps = __rest(props, ["name", "label", "span", "validate", "validateSchema", "required", "viewPermission", "editPermission"]);
        var formItemProps = { name: name, label: label, span: span, validate: validate, validateSchema: validateSchema, required: required, viewPermission: viewPermission, editPermission: editPermission };
        return (react_1.default.createElement(FormItem, __assign({}, formItemProps),
            react_1.default.createElement(WrappedComponent, __assign({ name: name }, fieldProps))));
    };
};
exports.default = FormItem;
